(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const headers = document.querySelectorAll(".faq-accordion-header");

  headers.forEach(function(header) {
    header.addEventListener("click", function() {
      const parent = header.parentElement;
      const content = header.nextElementSibling;
      const blockWrapper = parent.closest(".faq-block");

      if (!parent.classList.contains("active")) {
        const allAccordions = blockWrapper
          ? blockWrapper.querySelectorAll(".faq-accordion")
          : document.querySelectorAll(".faq-accordion");

        allAccordions.forEach(function(accordion) {
          if (accordion !== parent && accordion.classList.contains("active")) {
            accordion.classList.remove("active");
            const accordionContent = accordion.querySelector(".faq-accordion-content");
            if (accordionContent) {
              accordionContent.style.maxHeight = 0;
            }
          }
        });
      }

      parent.classList.toggle("active");
      if (parent.classList.contains("active")) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = 0;
      }
    });
  });
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
